module.exports = __webpack_public_path__ + "fa55170b2b0937f9490efc8607b34feb.gif";